var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMessageButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#7069FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3078 22.6923L24.1539 17.8462M29.1113 14.8887L25.0207 28.1833C24.6541 29.3747 24.4706 29.9707 24.1544 30.1683C23.8802 30.3396 23.5406 30.3683 23.2419 30.2443C22.8975 30.1014 22.618 29.5433 22.0603 28.428L19.4694 23.2461C19.3809 23.0691 19.3366 22.981 19.2775 22.9043C19.225 22.8363 19.1645 22.7749 19.0965 22.7225C19.0215 22.6647 18.9349 22.6214 18.7658 22.5369L13.5719 19.9399C12.4566 19.3823 11.8989 19.1032 11.756 18.7588C11.6321 18.4601 11.6603 18.1202 11.8317 17.846C12.0293 17.5297 12.6252 17.346 13.817 16.9793L27.1116 12.8887C28.0486 12.6004 28.5173 12.4563 28.8337 12.5725C29.1094 12.6737 29.3267 12.8908 29.4279 13.1665C29.544 13.4828 29.3999 13.9513 29.1119 14.8873L29.1113 14.8887Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessageButton);
export default __webpack_public_path__ + "static/media/sendMessageButton.e917db51af36e23beb022bc982996544.svg";
export { ForwardRef as ReactComponent };